import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService implements OnDestroy {
  private socket!: WebSocket;
  private pingInterval!: any;

  constructor(private ws: PostmethodService) {}

  getToDo() {
    return this.ws.wsGet(environment.baseUrl + "/lead/todoSummary");
  }

  getMasters() {
    return this.ws.wsGet(environment.baseUrl + "/admin/master/masterRecords");
  }

  newLeadData = new Subject<any>();
  isConnected: boolean = false;
  closeData = new Subject<any>();

  connect(): void {
    let userId: any = '';
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        userId = loginResponse.data?.user?.id;
      }
    }
    if (userId) {
      if (!this.socket || this.socket.readyState == WebSocket.CLOSED) {
        this.socket = new WebSocket(environment.webSocketUrl + `?userId=${userId}`);
        console.log(`[${new Date().toLocaleTimeString()}] WebSocket connecting to:`, environment.webSocketUrl + `?userId=${userId}`);
      } 
    }  

    this.socket.onopen = () => {
      console.warn('WebSocket connection opened');
      this.isConnected = true;
      // Start sending pings every 30 seconds
      this.pingInterval = setInterval(() => {
        if (this.socket.readyState === WebSocket.OPEN) {
          this.socket.send(JSON.stringify({ type: 'ping' }));
        }
      }, 30000);
    };

    this.socket.onmessage = (event) => {
      console.log(`Message from server [${new Date().toLocaleTimeString()}]:`, event.data);
      try {
        let serverData: any = JSON.parse(event.data); // Ensure JSON parsing if needed
        setTimeout(() => {
          this.newLeadData.next(serverData); // Emit data via Subject
          console.log('Emit triggered with data:', serverData);
        }, 100);
      } catch (error) {
        console.error('Invalid JSON received:', event.data, error);
      }
    };
    

    this.socket.onerror = (error) => {
      console.error('WebSocket error: ', error);
    };

    this.socket.onclose = () => {
      console.log(`[${new Date().toLocaleTimeString()}] WebSocket connection closed`);
      this.isConnected = false;
      this.closeData.next('closed');
      // Clear the ping interval when the connection is closed
      clearInterval(this.pingInterval);
    };
  }

  get leadData() {
    return this.newLeadData.asObservable();
  }

  close(): void {
    if (this.isConnected) {
      this.socket.close();
      this.newLeadData.complete();
      clearInterval(this.pingInterval);
    }
  }

  ngOnDestroy(): void {
    this.close();
  }

  get closedData() {
    return this.closeData.asObservable();
  }
}
